/**
 * 图片压缩
 */
export default function compressImg(img) {
  const path = img.attr('src')
  if (path.length < 2000000) {
    // 小于 200K的压缩
    return path
  }
  let width = this.width
  let height = this.height
  // 用于压缩图片的canvas
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  const initSize = img.src.length
  let ratio
  if ((ratio = (width * height) / 4000000) > 1) {
    ratio *= 10
    width /= ratio
    height /= ratio
  } else {
    ratio = 5
  }
  canvas.width = width * 2
  canvas.height = height * 2
  // 铺底色
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(img[0], 0, 0, width * 2, height * 2)
  // 进行最小压缩
  const dataURL = canvas.toDataURL('image/jpeg', 1)

  console.log('压缩前：' + initSize)
  console.log('压缩后：' + dataURL.length)
  console.log('压缩率：' + ~~((100 * (initSize - dataURL.length)) / initSize) + '%')
  console.log(dataURL)
  return dataURL
}
